
export const professionList= [
    {
     "ID": 1,
     "Profession": "Finance Advisor",
     "IsActive": true,
     "CreatedBy": null,
     "CreatedOn": null,
     "ModifiedBy": null,
     "ModifiedOn": null
   },
   {
     "ID": 2,
     "Profession": "LIC Agent",
     "IsActive": true,
     "CreatedBy": null,
     "CreatedOn": null,
     "ModifiedBy": null,
     "ModifiedOn": null
   },
   {
     "ID": 3,
     "Profession": "Equity Analyst",
     "IsActive": true,
     "CreatedBy": null,
     "CreatedOn": null,
     "ModifiedBy": null,
     "ModifiedOn": null
   },
   {
     "ID": 4,
     "Profession": "Mutual Fund Manager",
     "IsActive": true,
     "CreatedBy": null,
     "CreatedOn": null,
     "ModifiedBy": null,
     "ModifiedOn": null
   },
   {
     "ID": 5,
     "Profession": "Financial Manager",
     "IsActive": true,
     "CreatedBy": null,
     "CreatedOn": null,
     "ModifiedBy": null,
     "ModifiedOn": null
   },
   {
     "ID": 6,
     "Profession": "Trainer",
     "IsActive": true,
     "CreatedBy": null,
     "CreatedOn": null,
     "ModifiedBy": null,
     "ModifiedOn": null
   },
   {
     "ID": 7,
     "Profession": "Investment Advisor ",
     "IsActive": true,
     "CreatedBy": null,
     "CreatedOn": null,
     "ModifiedBy": null,
     "ModifiedOn": null
   },
   {
     "ID": 8,
     "Profession": "Student",
     "IsActive": true,
     "CreatedBy": null,
     "CreatedOn": null,
     "ModifiedBy": null,
     "ModifiedOn": null
   },
   {
     "ID": 9,
     "Profession": "Business",
     "IsActive": true,
     "CreatedBy": null,
     "CreatedOn": null,
     "ModifiedBy": null,
     "ModifiedOn": null
   },
   {
     "ID": 10,
     "Profession": "Private",
     "IsActive": true,
     "CreatedBy": null,
     "CreatedOn": null,
     "ModifiedBy": null,
     "ModifiedOn": null
   },
   {
     "ID": 11,
     "Profession": "Other",
     "IsActive": true,
     "CreatedBy": null,
     "CreatedOn": null,
     "ModifiedBy": null,
     "ModifiedOn": null
   }
 ]
